module.exports = __webpack_public_path__ + "static/media/E_WHITOUT_B_Warm-Grey-3C.69d0518d.jpg";